import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { DriverTachoMode, TachoService } from "@services/tacho.service";
import "./tachoMode.scss";

interface ITachoModeComponentBindings {
    tachoMode: DriverTachoMode;
}

@Component({
    selector: "tacho-mode",
    template: `<img class='tacho-image' [src]='tachoImageUrl' />`
})
export class TachoModeComponent implements OnChanges, ITachoModeComponentBindings {
    @Input() tachoMode: DriverTachoMode;
    tachoImageUrl: string;

    constructor(private tachoService: TachoService) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return;
        }

        this.updateModeInformation();
    }

    updateModeInformation() {
        if (this.tachoMode !== null) {
            this.tachoImageUrl = this.tachoService.getModeImage(this.tachoMode);
        }
        else {
            console.warn("No tacho mode found", this.tachoMode);
        }
    }
}

@Component({
    selector: "tacho-mode-status",
    template: `{{status}}`
})
export class TachoModeStatusComponent implements OnChanges, ITachoModeComponentBindings {
    @Input() tachoMode: DriverTachoMode;
    status: string;

    constructor(private tachoService: TachoService) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return;
        }

        this.updateModeInformation();
    }

    updateModeInformation() {
        if (this.tachoMode !== null) {
            this.status = this.tachoService.getModeMessage(this.tachoMode);
        }
        else {
            console.warn("No tacho mode found", this.tachoMode);
        }
    }
}
